<section class="lux-profile">

  <!-- DASHBOARD VIEW -->
  <div *ngIf="form === 0">

    <!-- STATS -->
   <div class="lux-stats">

  <div class="lux-stat">
    <span>Profit Balance</span>
    <h3>{{ acc | currency }}</h3>
    <small>{{ (+acc / 130) | number:'1.2-2' }} g</small>
  </div>

  <div class="lux-stat">
    <span>Referral Balance</span>
    <h3>${{ totref }}</h3>
    <!-- <small>{{ (+totref / 130) | number:'1.2-2' }} g</small> -->
  </div>

  <div class="lux-stat">
    <span>Deposits</span>
    <h3>${{ totdep }}</h3>
    <small>{{ (depositGrams / 130) | number:'1.2-2' }} g</small>
  </div>

  <div class="lux-stat">
    <span>Withdrawals</span>
    <h3>{{ totwith | currency }}</h3>
    <small>{{ (+totwith / 130) | number:'1.2-2' }} g</small>
  </div>


   <div class="lux-stat">
    <span>Pending Withdrawals</span>
    <h3>{{ pwith | currency }}</h3>
    <small>{{ (+pwith / 130) | number:'1.2-2' }} g</small>
  </div>

</div>

    <!-- ACTION BUTTONS -->
    <div class="lux-actions">
      <a routerLink="/dashboard" class="lux-btn gold">Buy</a>
      <a routerLink="/dashboard/withdrawal" class="lux-btn outline">Withdraw</a>
    </div>

    <!-- REFERRAL -->
    <div class="lux-ref">
      <input id="refUrl" [value]="location + '/signup?ref=' + profileId" readonly />
      <button type="button" (click)="copy()">Copy</button>
    </div>

    <!-- MENU -->
    <div class="lux-menu">

      <div class="lux-item" (click)="openForm('Crypto')">Add Crypto Wallet</div>

      <div class="lux-item" *ngIf="country == 'India'" (click)="openForm('upi')">
        Add UPI
      </div>

      <div class="lux-item" *ngIf="country == 'India'" (click)="openForm('Bank')">
        Add Bank
      </div>

      <a class="lux-item">Referrals</a>
      <a class="lux-item" [href]="whatsappLink">Support</a>
      <!-- <a class="lux-item" routerLink="/about">About Us</a> -->

      <div class="lux-item logout" (click)="logOut()">Logout</div>

    </div>

  </div>

  <!-- FORM VIEW -->
  <form #so="ngForm" (ngSubmit)="update()" *ngIf="form === 1">

    <div class="lux-form">

      <!-- BANK -->
      <div *ngIf="address === 'Bank' && country == 'India'">
        <input class="lux-input" [(ngModel)]="bankname" name="bankname" placeholder="Bank Name" required>
        <input class="lux-input" [(ngModel)]="bankacc" name="bankacc" placeholder="Account Name" required>
        <input class="lux-input" [(ngModel)]="banknum" name="banknum" placeholder="Account Number" required>
        <input class="lux-input" [(ngModel)]="bankifsc" name="bankifsc" placeholder="IFSC Code" required>
      </div>

      <!-- CRYPTO -->
      <div *ngIf="address === 'Crypto'">
        <input class="lux-input" [(ngModel)]="ripple" name="ripple" placeholder="Ripple">
        <input class="lux-input" [(ngModel)]="usdttrc" name="usdttrc" placeholder="USDT TRC20">
        <input class="lux-input" [(ngModel)]="usdtbep" name="usdtbep" placeholder="USDT BEP20">
        <input class="lux-input" [(ngModel)]="eth" name="eth" placeholder="Ethereum">
        <input class="lux-input" [(ngModel)]="btc" name="btc" placeholder="Bitcoin">
      </div>

      <!-- UPI -->
      <div *ngIf="address === 'upi'">
        <input class="lux-input" [(ngModel)]="upi" name="upi" placeholder="UPI ID">
        <input class="lux-input" [(ngModel)]="upname" name="upiU" placeholder="UPI Username">
      </div>

      <!-- PASSWORD -->
      <div *ngIf="address === 'password'">
        <input class="lux-input" [(ngModel)]="newpass" name="newpass" placeholder="New Password" type="password">
      </div>

      <!-- ACTION -->
      <div class="lux-form-actions">
        <button type="button" class="lux-btn gold" (click)="address='pass'">
          Update Profile
        </button>

        <button type="button" class="lux-btn outline" (click)="cancel()">
          Cancel
        </button>
      </div>

    </div>

    <!-- CONFIRM -->
    <div class="lux-confirm" *ngIf="address === 'pass'">

      <h4>Confirm Update</h4>
      <p>Enter your current password to complete update</p>

      <input class="lux-input center"
             [(ngModel)]="cpass"
             name="cpass"
             type="password"
             placeholder="Current Password"
             required />

      <button class="lux-btn gold" [disabled]="!cpass">
        Submit
      </button>

      <a (click)="cancel()">Cancel</a>

    </div>

  </form>

</section>
